import { AbstractPersistentFilter } from './AbstractPersistentFilter.mjs'
import { redact } from '../utils/redact.mjs'

export class ContainsUrlFilter extends AbstractPersistentFilter {
  static TYPE = 'contains'
  constructor(opts = {}) {
    if (!opts.value)
      throw new Error('ContainsUrlFilters require a target value')
    super(ContainsUrlFilter.TYPE, opts)
    if (!opts.size && opts.secure)
      throw new Error('Secure ContainsUrlFilters require a target size')
    this.size = opts.size || null
  }
  matches(url) {
    if (!url || !this.value) return false
    let size = this.size || this.value.length
    if (url.length < size) return false
    if (!this.secure) {
      return url.includes(this.value)
    }
    // In this case, we are looking for a substring match, but we only know the
    // length of the substring, not its position. So we have to search the entire
    // string for a match of the given length.
    for (let i = 0; i <= url.length - size; i++) {
      const substr = url.slice(i, i + size)
      if (redact(substr) === this.value) {
        return true
      }
    }
    return false
  }

  /** Assume exclusive **/
  explain(url) {
    if (this.secure) {
      return 'Your settings prevent this URL from being displayed'
    }
    return `${this.value} URLs are filtered out by your settings`
  }

  get simpleLabel() {
    return `**${this.value}**`
  }

  get label() {
    return `URL contains “${this.secure ? `[redacted]` : this.value}”`
  }

  toJson() {
    return {
      ...super.toJson(),
      size: this.size,
    }
  }
}
